import React, { Component } from 'react'
import Profile from './Profile'
import Intelligence from './Intelligence'
import AreaOfOperations from './AreaOfOperations'
import Contact from './Contact'
import AboutUs from './AboutUs'
import IndustryServed from './IndustryServed'
import Map from './Map'
import KeyFocusArea from './KeyFocusArea'
import Customers from './Customers'
import ManPower from './ManPower'
import Warehousing from './Warehousing'
import ValueAddedServices from './ValueAddedServices'
import AcceptableTerms from './AcceptableTerms'
import TruckAssetsDetails from './TruckAssestsDetails'
import BankDetails from './BankDetails'
import GSTDetails from './GSTDetails'
import Other from './Other'
import ShipmentMethod from './ShipmentMethod'
import { Urls } from '../../../Urls'
import axios from 'axios'
import Loader from '../../Loader'
import './style.css'
import PopupWidget from '../../PopupModal/PopupModal'
// import marketing from '../../../Content/images/upper_part.jpg'
import mid_image from '../../../Content/images/mid_image.jpg'
import logo from '../../../Content/images/logo-lorri.png'
import footer from '../../../Content/images/shell.jpg'
import { encryptor, Activity } from '../../../Constants'
import Licenses from "./LicensesAndCertifications/Licenses"
import AdditionalDetails from './AdditionalDetails/AdditionalDetails'
import TmsExperience from './TMSExperience/TMS'



let transporter_data;
class PopupContent extends Component {
  constructor(props) {
    super(props)
  }

  render() {

    return <div>
      <div className="lorri_logo_div">
        <img className="lorri_logo shadow" src={logo} />
      </div>
      <hr />
      <div>
        <div style={{ textAlign: "center", fontSize: "x-large" }}>
          <div><b>Want to know more about {this.props.transporter.transporter_name} and hundreds of other transporters?</b></div>
          <div style={{color:'steelblue'}}>In 2 minutes sign-up for free and unleash the power of LoRRI.</div>
        </div>
      </div>
      <div className="marketing_login_button">
        <button className="btn btn-primary custom_button_login shadow-lg p-3 mb-5 bg-white rounded" onClick={e => window.open(`https://company.lorri.in/tpmp/${encryptor(this.props.transporter.transporter_id, true)}`, '_blank', 'noopener,noreferrer')}><i class="fas fa-unlock" style={{ paddingRight: "5%", fontSize: '75%' }} /><span style={{ fontSize: '80%' }}>Click to Sign-Up</span></button>
      </div>
      <hr />
      <div className="feature-list shadow">
        <div><img className="marketing_image" src={mid_image} /></div>
      </div>
      <hr />
      {/* <div className="feature-list shadow">
        <img className="marketing_image" src={footer} />
      </div> */}

    </div>
  }
}
class TransporterDetailsBody extends Component {
  constructor(props) {
    super(props)
    this.state = {
      transporter_data: '',
      map_data: '',
      loader: false
    }
  }
  componentWillMount() {

    let transporter_id = this.props.match.params.name

    if (transporter_id != undefined && transporter_id != null && transporter_id != '') {
      this.setState({ loader: true }, () => {
        // axios.get(`${Urls.Transporters.Get}?profile_code=eI38CIAAANOACAAYAAgAAoAIAAhgAwBAVzbi7kinChIcRv4EQA=`)
        axios.get(`${Urls.Transporters.Get}?profile_code=${transporter_id}`)
          .then(res => {
            Activity([{ "screen": "lorri portal", "module":"profile", "user_activity": `Profile viewed:${res.data.transporter_name}`, "timestamp": new Date().toISOString() }])

            this.setState(
              {
                transporter_data: res.data,
                loader: false

              }, () => { }
            )

            sessionStorage.setItem('tns_name', res.data.transporter_name)
          })
          .catch(err => {
            console.log(err);
            this.setState({ loader: false })
          })
      })
    }
  }

  render() {
    return (
      <div className="body jumbotron">
        <PopupWidget content={<PopupContent transporter={this.state.transporter_data} />} Header=""></PopupWidget>
        <div className="row client_body">


          <div className="col-lg-4 col-md-4 left_col">
            <div className="row">
              <div className="col-12 profile hovertest">
                <Profile transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-12 aboutUs hovertest">
                <AboutUs transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-12 industryServed hovertest">
                <IndustryServed transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-12 keyFocusArea hovertest">
                <KeyFocusArea transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-12 acceptableTerms hovertest">
                <AcceptableTerms transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-12 bankDetails hovertest">
                <BankDetails transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-12 otherBusinessInterest hovertest">
                <Other transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-12 otherBusinessInterest hovertest">
                        {/* <Other transporter_data={this.state.transporter_data} /> */}
                        <AdditionalDetails transporter_data={this.state.transporter_data} />
                      </div>
            </div>
          </div>

          <div className="col-lg-8 col-md-8 right_col" style={{ height: '100%' }}>
            <div className="row">
              <div className="col-lg-8 col-md-8 intelligence hovertest">
                <Intelligence intelligencedata={this.state.transporter_data} />
              </div>
              <div className="col-lg-3 col-md-3 col-md-3 areaOfOperations hovertest">
                <AreaOfOperations transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-lg-11 contactInformation " style={{ width: '100%' }}>
                <Contact transporter_data={this.state.transporter_data} style={{ width: '100%' }} />
              </div>
              <div className="col-lg-11 map" style={{ paddingLeft: '0px', paddingRight: '0px', marginRight: '0px' }}>
                <Map map_data={this.state.transporter_data} />
              </div>
              <div className="col-lg-11 customers hovertest">
                <Customers topCompanies={this.state.transporter_data} />
              </div>

              <div className="col-lg-4 warehouseService hovertest">
                <Warehousing transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-lg-7 gst hovertest">
                <GSTDetails transporter_data={this.state.transporter_data} />
              </div>

              <div className="col-lg-11 truckAssetDetails hovertest">
                <TruckAssetsDetails truckAssetDetails={this.state.transporter_data} />
              </div>
              <div className="col-lg-7 valueAddedService hovertest">
                <ValueAddedServices transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-lg-5 manPower hovertest" >
                <ManPower transporter_data={this.state.transporter_data} />
              </div>
              <div className="col-lg-6 shipmentMethod hovertest">
                        {/* <ShipmentMethod methodDetails={this.state.transporter_data} />  */}
                        <Licenses transporter_data={this.state.transporter_data} /> 
                      </div>
              <div className="col-lg-5 shipmentMethod hovertest">
                        {/* <ShipmentMethod methodDetails={this.state.transporter_data} />  */}
                        <TmsExperience transporter_data={this.state.transporter_data} /> 
                      </div>
              <div className="col-lg-11 shipmentMethod hovertest">
                <ShipmentMethod methodDetails={this.state.transporter_data} />
              </div>
            </div>
          </div>


        </div>
        <Loader show={this.state.loader} message={'Loading Transporter Details'} />
      </div>
    )
  }
}
export default TransporterDetailsBody;